import Link from "next/link";
import styled from "styled-components";
import { SocialIcon } from "react-social-icons";


export const SocialLink = styled(Link)`
  margin-right: 1rem;
  &:hover {
    opacity: 0.8;
  }
  @media (min-width: 1000px) {
    margin-right: 0rem;
  }
`;



export const StyledSocialIcon = styled(SocialIcon)`
  cursor: hand;
  border-radius: 250px; 
  pointer-events: auto;
  overlay-index: -1;
  &:hover {
    opacity: 1;
    border: 2px solid #fff; 
  }
`